import runtime from 'react/jsx-runtime';

// Keep React's actual factory functions. ESM bindings let the production
// minifier call them directly instead of repeating CommonJS member calls for
// every JSX element. React still chooses its own development/production build.
export const jsx = runtime.jsx;
export const jsxs = runtime.jsxs;
export const Fragment = runtime.Fragment;
